export default __webpack_public_path__ + "static/media/moving.6686cc3e.jpg";